import { ActionTypes } from '../constans/action-types';

export const openSnackbar = (type, msg, isMasterAction = false, duration = null) => ({
  type: ActionTypes.OPEN_SNACKBAR,
  payload: { type, msg, isMasterAction, duration },
});

export const closeSnackbar = () => ({
  type: ActionTypes.CLOSE_SNACKBAR,
});
